var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1209_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1C12.3478 1 9.80423 2.05356 7.92909 3.92909C6.05364 5.80423 5 8.34785 5 11C5 13.6522 6.05356 16.1958 7.92909 18.0709C9.80423 19.9464 12.3478 21 15 21C17.6522 21 20.1958 19.9464 22.0709 18.0709C23.9464 16.1958 25 13.6522 25 11C25 8.34785 23.9464 5.80423 22.0709 3.92909C20.1958 2.05364 17.6522 1 15 1ZM15 19.2607C12.8091 19.2607 10.708 18.3906 9.1589 16.8412C7.60945 15.292 6.73935 13.1909 6.73935 11.0001C6.73935 8.80926 7.60945 6.70811 9.1589 5.15898C10.708 3.60953 12.8092 2.73943 15 2.73943C17.1908 2.73943 19.292 3.60953 20.8411 5.15898C22.3906 6.70811 23.2607 8.80926 23.2607 11.0001C23.2607 13.1909 22.3906 15.292 20.8411 16.8412C19.292 18.3906 17.1908 19.2607 15 19.2607Z",
    fill: "#96A8BA",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.805 10.4267V7.87502C16.1986 7.97362 16.5616 8.16995 16.8613 8.44625C17.1866 8.75951 17.7012 8.74662 18.011 8.41759C18.3204 8.08855 18.3076 7.56778 17.9823 7.25477C17.3751 6.69272 16.6179 6.3241 15.805 6.1946V5.15505C15.805 4.70105 15.4414 4.33334 14.9926 4.33334C14.5437 4.33334 14.1802 4.70107 14.1802 5.15505V6.21925C13.8064 6.28919 13.446 6.41816 13.1117 6.60131C12.3381 6.9653 11.8014 7.70337 11.6886 8.5589C11.5759 9.41473 11.9026 10.2692 12.5551 10.8255C13.0176 11.2585 13.5741 11.5753 14.1802 11.7498V14.3099C13.7877 14.2127 13.425 14.0193 13.1239 13.7467C12.7966 13.4572 12.3018 13.4796 12.0014 13.7977C11.7011 14.1158 11.7016 14.6168 12.0029 14.9344C12.6092 15.4962 13.367 15.8639 14.1802 15.9903V16.845C14.1802 17.2987 14.5438 17.6667 14.9926 17.6667C15.4414 17.6667 15.805 17.2987 15.805 16.845V15.978C16.189 15.9055 16.5601 15.7751 16.9059 15.5916C17.6769 15.2219 18.2079 14.4793 18.3139 13.6229C18.4201 12.7668 18.0866 11.9147 17.4301 11.3638C16.9676 10.9279 16.4114 10.6072 15.805 10.4268V10.4267ZM13.6804 9.63363C13.4301 9.42154 13.2893 9.10512 13.2987 8.77494C13.3743 8.45308 13.5914 8.18366 13.8878 8.0435C13.9813 7.99335 14.079 7.95207 14.1802 7.92026V9.97471C13.9926 9.887 13.8189 9.77207 13.6642 9.63364L13.6804 9.63363ZM16.7027 13.4181C16.6287 13.7397 16.4111 14.0085 16.1139 14.1452C16.0104 14.2025 15.9013 14.2495 15.7888 14.2848V12.1854C15.9829 12.2785 16.1623 12.4003 16.321 12.5468C16.5738 12.7626 16.7146 13.0836 16.7027 13.4181Z",
    fill: "#96A8BA",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1209_1510",
    x: 0.849976,
    y: 0.850006,
    width: 28.3,
    height: 28.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1209_1510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1209_1510",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCost);
export default __webpack_public_path__ + "static/media/cost.41abe054a41cddaeb24f65c78cc5a6ca.svg";
export { ForwardRef as ReactComponent };